import { __decorate, __metadata } from "tslib";
import { IsUndefinable, LengthWithLVS, MatchesWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsDefined, IsLowercase, IsNotEmpty, IsOptional, IsString, IsUUID, ValidateNested } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
import { ReadWebMerchantAppComponentsDto } from './ReadWebMerchantAppComponentsDto';
import { ReadWebMerchantAppDto } from './ReadWebMerchantAppDto';
import { ReadWebMerchantCustomNavigationLinkDto } from './ReadWebMerchantCustomNavigationLinkDto';
import { ReadWebMerchantFontSourcesDto } from './ReadWebMerchantFontSourcesDto';
import { ReadWebMerchantMetadataDto } from './ReadWebMerchantMetadataDto';
import { ReadWebMerchantThemeDto } from './ReadWebMerchantThemeDto';
export class ReadWebMerchantDto {
}
__decorate([
    ApiProperty({ type: () => String, description: 'ref to merchant.merchantId', example: 'ddfb5654-7fe1-40de-8be8-041116c8f267' }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebMerchantDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
            WebMerchantExposeGroup.SEARCH,
        ],
    }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    IsLowercase({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    MatchesWithLVS(/[a-z-]+/, { always: true }),
    IsUndefinable({ groups: [WebMerchantExposeGroup.SEARCH, WebMerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebMerchantDto.prototype, "slug", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
            WebMerchantExposeGroup.SEARCH,
        ],
    }),
    IsOptional({ always: true }),
    IsUndefinable({ groups: [WebMerchantExposeGroup.SEARCH, WebMerchantExposeGroup.PATCH] }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantDto.prototype, "hostname", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Uses for set webstore for default styling' }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    IsUUID('4', { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantDto.prototype, "defaultStyleWebStoreId", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantDto.prototype, "title", void 0);
__decorate([
    ApiProperty({ type: () => ReadWebMerchantMetadataDto }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsDefined({ groups: [WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ groups: [WebMerchantExposeGroup.PATCH] }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantMetadataDto),
    __metadata("design:type", ReadWebMerchantMetadataDto)
], ReadWebMerchantDto.prototype, "metadata", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantThemeDto }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ groups: [WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    ValidateNested({ groups: [WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    Type(() => ReadWebMerchantThemeDto),
    __metadata("design:type", ReadWebMerchantThemeDto)
], ReadWebMerchantDto.prototype, "theme", void 0);
__decorate([
    ApiProperty({ type: () => ReadWebMerchantAppComponentsDto }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsDefined({ groups: [WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantAppComponentsDto),
    __metadata("design:type", ReadWebMerchantAppComponentsDto)
], ReadWebMerchantDto.prototype, "components", void 0);
__decorate([
    ApiProperty({ type: () => [ReadWebMerchantCustomNavigationLinkDto] }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    ValidateNested({ each: true, always: true }),
    Type(() => ReadWebMerchantCustomNavigationLinkDto),
    __metadata("design:type", Array)
], ReadWebMerchantDto.prototype, "customNavigationLinks", void 0);
__decorate([
    ApiProperty({ type: () => ReadWebMerchantAppDto }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsDefined({ groups: [WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ groups: [WebMerchantExposeGroup.PATCH] }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantAppDto),
    __metadata("design:type", ReadWebMerchantAppDto)
], ReadWebMerchantDto.prototype, "app", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantFontSourcesDto, isArray: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantFontSourcesDto),
    __metadata("design:type", Array)
], ReadWebMerchantDto.prototype, "fontSources", void 0);
//# sourceMappingURL=ReadWebMerchantDto.js.map